import React from 'react';
import {useStyles} from "./ShowTraceType.style";
import clsx from "clsx";
import {Tooltip} from "@material-ui/core";
import ShowTraceTypeProperties from "./ShowTraceTypeProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import TraceType from '../../../entities/TraceType';
import AddIcon from '@mui/icons-material/Add';
import PostAddIcon from '@mui/icons-material/PostAdd';
import AssignmentIcon from '@mui/icons-material/Assignment';

const ShowTraceType: React.FC<ShowTraceTypeProperties> = ({
                                                                  traceType,
                                                                  className = '',
                                                                  tooltip,
                                                                  label,
                                                              }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    if (!traceType) return <></>

    const getIcon = () => {
        switch (traceType) {
            case TraceType.PRODUCT_ORDER_CREATED_TRACE:
                return <AddIcon/>;
            case TraceType.PRODUCT_ORDER_OBSERVATION_TRACE:
                return <PostAddIcon/>;
            case TraceType.MISCELLANY_ORDER_DESCRIPTION_TRACE:
                return <AssignmentIcon/>;
        }
    }
    const getClass = () => {
        switch (traceType) {
            case TraceType.PRODUCT_ORDER_CREATED_TRACE:
            case TraceType.PRODUCT_ORDER_OBSERVATION_TRACE:
            case TraceType.MISCELLANY_ORDER_DESCRIPTION_TRACE:
                return classes.pending;
        }
    }

    return (
        <Tooltip title={tooltip || ""}>
            <div className={clsx(classes.display_field_container, className, getClass())}>
                <div className={classes.value}>
                    {getIcon()}
                    {i18n.translate(`${traceType}`)}
                </div>
            </div>
        </Tooltip>
    )
}
export default ShowTraceType;